import { FC, useState, useContext, useRef, SetStateAction, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import { AuthenticationModalProps } from "../../interfaces";
import useStyles from "../Styles/ProjectModalStyles";
import copy from "../../assets/images/copySecondary.svg";
import { Formik, Form } from "formik";
import cross from "../../assets/images/cross.svg";
import AlertContext from "../../store/Alert/AlertContext";
import AuthContext from "../../store/Auth/AuthContext";
import QRCode from "qrcode"

import VerificationInput from "react-verification-input";
const AuthenticationModal: FC<AuthenticationModalProps> = ({
  open,
  setOpen,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const {secretToken, otpAuthUrl, enable2FA} = useContext<any>(AuthContext);
  const [codeValue, setcodeValue] = useState("");
  const [error, setError] = useState(false);
  const [qrImage, setqrImage] = useState("");
  const text = useRef<any>();
  const { setAlert } = useContext<any>(AlertContext);

  function setcodeValues(val: any) {
    console.log(val.length);
    if (val.length === 6) {
      setcodeValue(val);
    } else {
      setError(false);
    }
  }

  const copytext = async (event: any) => {
    event.preventDefault();
    navigator.clipboard.writeText(text.current.value);
    setAlert("Sceret Code Copied!!", "success");
  };

  const handleClose = () => {
    setOpen(false);
    setError(false);
  };

  useEffect(() => {
    QRCode.toDataURL(otpAuthUrl, function(err: any, data_url: SetStateAction<string>) {
        console.log(data_url);
        setqrImage(data_url)
    });
  }, [otpAuthUrl])

  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages} ${classes.twofamodal}`}
        >
          <Box
            ml={isActive ? "20px" : 7}
            mt={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 3}
            mb={isActive ? "20px" : 4}
          >
            <Box className="relative-box">
              {!isActive && (
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  onClick={handleClose}
                />
              )}
              <ProjectPoolHeading
                title1="Two factor  "
                title2="Authentication"
              />
              <Box>
                <Typography variant="body1" className="fw-normal t-color">
                  Scan QR code below in Google Authenticator
                </Typography>
              </Box>
              <Box mt={2} ml="-12px">
                  
                <img src={qrImage} alt="gains" />
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1" className="fw-normal ">
                  Copy 2FA Authentication Secret
                </Typography>
                
                <Box
                  className="border-box"
                  display="flex"
                  alignItems="center"
                  pl={2}
                  pr={2}
                  py={"12px"}
                  mr={isActive ? 0 : 5}
                >
                  <Box mr={isActive ? 5 : 2} style={{flex:'1'}}>
                    <Typography
                      variant="body1"
                      className="fw-normal text-grey fs-13"
                    >
                      {isActive
                        ?  secretToken?.substr(0, 20)
                        : secretToken}
                    </Typography>
                    
                  </Box>
                  <Box>
                    <Button
                      className=""
                      variant="text"
                      onClick={copytext}
                      startIcon={<img src={copy} alt="" />}
                    >
                      <Typography variant="subtitle1" className="fw-bold">
                        copy
                      </Typography>
                    </Button>
                  </Box>
                </Box>
                <input className="hiddeninput" onChange={(e)=> e.preventDefault} value={secretToken} ref={text} />
              </Box>
              <Box mt={2}>
                <Typography
                  variant="subtitle1"
                  className="fw-normal "
                  color="secondary"
                >
                  Enter Code from Authenticator
                </Typography>
              </Box>
              <Box mt={1}>
                <Formik
                  initialValues={{}}
                  onSubmit={(values) => {
                    if (codeValue.length === 6) {
                      enable2FA(codeValue);
                      setError(false);
                      setOpen(false);
                    }
                    else { 
                       setError(true);
                    }
                  }}
                >
                  <Form>
                    <Box mt={isActive ? 2 : 2} className="pt-0">
                      <Grid container alignItems="center" spacing={0}>
                        <Grid item lg={7} md={7} sm={6} xs={12}>
                          <Box mb={isActive ? 1 : 0}>
                            <VerificationInput
                              removeDefaultStyles
                              placeholder=""
                              autoFocus={true}
                              validChars="0-9"
                              onChange={(e) => setcodeValues(e)}
                              classNames={{
                                character: "character",
                              }}
                            />
                          </Box>
                          {error && (
                            <Typography
                              variant="subtitle1"
                              className="error mt-12"
                            >
                              Please enter 6 digits code
                            </Typography>
                          )}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box
                            display="flex"
                            mt={isActive ? 3 : 5}
                            mb={isActive ? 0 : 3}
                          >
                            <Box mr={isActive ? 2 : 2} flexGrow={isActiveXS ? 1 : ""}>
                              <Button
                                variant="contained"
                                className="button-buy"
                                color="secondary"
                                type="submit"
                              >
                                Confirm
                              </Button>
                            </Box>
                            <Box ml={isActive ? 2 : 0} flexGrow={isActiveXS ? 1 : ""}>
                              <Button
                                className="button-buy"
                                variant="outlined"
                                color="secondary"
                                onClick={handleClose}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                </Formik>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default AuthenticationModal;
